import { snakeToCamel } from "caseparser";
import {
  CamelCasedPropertiesDeep,
  SnakeCasedPropertiesDeep,
  Except,
} from "type-fest";

export type HasId = {
  id: string;
};

export type HasStringDates = {
  created: string;
  updated: string;
};

export type HasDates = {
  created: Date;
  updated: Date;
};

export type HasCommonMeta = HasId & HasDates;

export type FromAPI<T extends object> = CamelCasedPropertiesDeep<T>;

export type FromAPIWithDates<T extends HasStringDates> =
  CamelCasedPropertiesDeep<Except<T, "created" | "updated">> & HasDates;

export function fromAPI<T extends object>(obj: T): FromAPI<T> {
  // @ts-expect-error Currently the return types in caseparser don't work recursively
  return snakeToCamel(obj);
}

export function fromAPIWithDates<T extends HasStringDates>(
  obj: T,
): FromAPIWithDates<T> {
  const { created, updated, ...rest } = fromAPI(obj);
  // @ts-expect-error Currently the return types in caseparser don't work recursively
  return {
    ...rest,
    created: new Date(created),
    updated: new Date(updated),
  };
}

// TODO: Needs some more work before being useful. Who wants to take this on?

export type ToAPI<T extends HasCommonMeta> = SnakeCasedPropertiesDeep<
  Except<T, keyof HasCommonMeta>
>;

export type ToAPIPatch<T extends HasCommonMeta> = Partial<ToAPI<T>>;

export function toAPI<T extends HasCommonMeta>(obj: T): ToAPI<T> {
  // @ts-expect-error Currently the return types in caseparser don't work recursively
  return camelToSnake(obj);
}

export type ToAPIWithDates<T extends HasDates> = SnakeCasedPropertiesDeep<
  Except<T, "created" | "updated"> & HasStringDates
>;
